import deepmerge from 'deepmerge';
import * as profiles from './index';

export type Profile = Record<string, any> & { name: string; inherits?: string };

/**
 * Loads a profile by name, resolving inheritance and merging parent/child profiles.
 * @param name The profile name to load (must match the 'name' field in the profile JSON)
 * @param loaded Used internally to detect circular inheritance
 */
export function loadProfile(name: string, loaded = new Set<string>()): Profile {
  if (loaded.has(name)) throw new Error(`Circular inheritance detected: ${name}`);
  loaded.add(name);

  // Find the profile by name among all exports
  const profile: Profile | undefined = Object.values(profiles).find(
    (p: any) => p && typeof p === 'object' && p.name === name
  ) as Profile | undefined;

  if (!profile) throw new Error(`Profile not found: ${name}`);

  if (profile.inherits) {
    const parent = loadProfile(profile.inherits, loaded);
    // Child properties override parent
    return deepmerge(parent, profile);
  }
  return profile;
} 